import Swiper from 'swiper/bundle';

const s1Slider = new Swiper('.js-s1-slider', {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 1,
    breakpoints: {
        1: {
            slidesPerView: 'auto',
        },
    },
    autoHeight: true,
    navigation: {
        nextEl: '.js-s1-next',
        prevEl: '.js-s1-prev',
    },
    pagination: {
        el: '.js-s1-pagination',
        clickable: true,
    },
    autoplay: {
        delay: 7000,
    },
});

const s2Slider = new Swiper('.js-s2-slider', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 28,
    breakpoints: {
        481: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 3,
        },
        1025: {
            slidesPerView: 4,
        },
        1920: {
            slidesPerView: 5,
        },
        2560: {
            slidesPerView: 6,
        },
    },
    autoplay: {
        delay: 7000,
    },
});

const footerSlider = new Swiper('.js-footer-slider', {
    loop: true,
    slidesPerView: 3,
    spaceBetween: 0,
    centeredSlides: true,
});

const bannersSlider = new Swiper('.js-banners-slider', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 42,
    breakpoints: {
        480: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 3,
        },
    },
    autoplay: {
        // delay: 5000,
    },
    navigation: {
        nextEl: '.js-banners-next',
        prevEl: '.js-banners-prev',
    },
});